import {
  faArrowLeft,
  faArrowRight,
  faArrowUpRightFromSquare,
  faEye,
  faFilter,
  faFilterCircleXmark,
  faPlus,
  faRefresh,
  faSearch,
  faTable,
  faTachometer,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Scroll from "react-scroll";

import { useRecoilState } from "recoil";

import toast from "react-hot-toast";
import { getReportDetailAPI } from "../../../API/Report";
import {
  userDetailState,
  usersCreatedState,
  userSessionsSessionTypeState,
  userSessionsShowFilterState,
  userSessionsSortedByState,
  usersSearchTextState,
  usersStatusState,
} from "../../../AppState";

import {
  deleteActivitiesAPI,
  getActivitiesListAPI,
} from "../../../API/Activities";
import FormErrorBox from "../../../Components/Reusable/FormErrorBox";
import FormInputFieldWithButton from "../../../Components/Reusable/FormInputFieldWithButton";
import FormSelectField from "../../../Components/Reusable/FormSelectField";
import PageLoadingContent from "../../../Components/Reusable/PageLoadingContent";
import {
  ACTIVITIES_LIST_OPTIONS,
  USER_CREATED_LIST_OPTIONS,
} from "../../../Constants/FieldOptions";

import ActivitiesListMobile from "./activitiesListMobile";
import ActivitiesListDesktop from "./activitiesListDesktop";

function Activities() {
  const { uid } = useParams();

  const [showFilter, setShowFilter] = useRecoilState(
    userSessionsShowFilterState
  );
  const [sessionType, setSessionType] = useRecoilState(
    userSessionsSessionTypeState
  );
  const [sortByValue, setSortByValue] = useRecoilState(
    userSessionsSortedByState
  );
  const [user] = useRecoilState(userDetailState);

  const [errors, setErrors] = useState({});
  const [selectedSessionForDeletion, setSelectedSessionForDeletion] =
    useState("");
  const [isFetching, setFetching] = useState(false);
  const [listData, setListData] = useState("");
  const [pageSize, setPageSize] = useState(100);
  const [previousCursors, setPreviousCursors] = useState([]);
  const [nextCursor, setNextCursor] = useState("");
  const [currentCursor, setCurrentCursor] = useState("");

  const [temporarySearchText, setTemporarySearchText] =
    useRecoilState(usersSearchTextState);
  const [status, setStatus] = useRecoilState(usersStatusState);
  const [created, setCreated] = useRecoilState(usersCreatedState);
  const [actualSearchText, setActualSearchText] = useState(temporarySearchText);

  function onUserDetailForSessionListSuccess(response) {
    setListData(response);
    if (response.hasNextPage) {
      setNextCursor(response.nextCursor);
    }
  }

  function onUserDetailForSessionListError(apiErr) {
    setErrors(apiErr);

    var scroll = Scroll.animateScroll;
    scroll.scrollToTop();
  }

  function onUserDetailForSessionListDone() {
    setFetching(false);
  }

  function onSessionDeleteSuccess(response) {
    toast.success("deleted Successfully");

    defaultFetchList();
  }

  function onSessionDeleteError(apiErr) {
    toast.error(apiErr.message);

    var scroll = Scroll.animateScroll;
    scroll.scrollToTop();
  }

  function onSessionDeleteDone() {
    setFetching(false);
  }

  const onClearFilterClick = (e) => {
    setShowFilter(false);
    setSessionType("");
    setSortByValue("completed_time,ASC");
  };

  const defaultFetchList = () => {
    fetchList(currentCursor, pageSize, sortByValue, uid, sessionType);
  };

  const onSearchButtonClick = (e) => {
    setActualSearchText(temporarySearchText);
  };

  const fetchList = (cur, limit, cdr, uid, st, n) => {
    setFetching(true);
    setErrors({});

    let params = new Map();
    params.set("page_size", limit);

    if (cdr !== undefined && cdr !== null && cdr !== "") {
      let end = Math.floor(Date.now() / 1000);

      let start = end - cdr * 24 * 60 * 60;

      params.set("start", start);
      params.set("end", end);
    }

    if (cur !== "") {
      params.set("cursor", cur);
    }

    if (uid !== "") {
      params.set("userId", uid);
    }

    if (st !== "") {
      params.set("activityType", st);
    }
    if (n !== "") {
      params.set("search", n);
    }

    getActivitiesListAPI(
      params,
      onUserDetailForSessionListSuccess,
      onUserDetailForSessionListError,
      onUserDetailForSessionListDone
    );
  };

  const onNextClicked = (e) => {
    let arr = [...previousCursors];
    arr.push(currentCursor);
    setPreviousCursors(arr);
    setCurrentCursor(nextCursor);
  };

  const onPreviousClicked = (e) => {
    let arr = [...previousCursors];
    const previousCursor = arr.pop();
    setPreviousCursors(arr);
    setCurrentCursor(previousCursor);
  };

  const onDeselectSessionForDeletion = (e) => {
    setSelectedSessionForDeletion("");
  };

  const onDeleteConfirmButtonClick = (e) => {
    deleteActivitiesAPI(
      selectedSessionForDeletion.id,
      onSessionDeleteSuccess,
      onSessionDeleteError,
      onSessionDeleteDone
    );
    setSelectedSessionForDeletion("");
  };

  const onReportClick = async (userID) => {
    try {
      setFetching(true);
      const response = await getReportDetailAPI(userID);

      if (response && response.data) {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = fileURL;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        toast.success("Report Created Successfully");
      } else {
        toast.error("Failed to generate report");
      }
    } catch (error) {
      toast.error("Error generating report");
    } finally {
      setFetching(false);
    }
  };

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      window.scrollTo(0, 0);
      fetchList(
        currentCursor,
        pageSize,
        created,
        uid,
        status,
        actualSearchText
      );
    }

    return () => {
      mounted = false;
    };
  }, [currentCursor, pageSize, created, uid, status, actualSearchText]);

  return (
    <>
      <div class="container">
        <section class="section">
          {/* Desktop Breadcrumbs */}
          <nav class="breadcrumb is-hidden-touch" aria-label="breadcrumbs">
            <ul>
              <li class="">
                <Link to="/dashboard">
                  <FontAwesomeIcon className="fas" icon={faTachometer} />
                  &nbsp;Dashboard
                </Link>
              </li>
              <li class="">
                <Link to="/users" aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faUsers} />
                  &nbsp;Users
                </Link>
              </li>
              <li class="is-active">
                <Link to={`/user`} aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faEye} />
                  &nbsp;Detail (Sessions)
                </Link>
              </li>
            </ul>
          </nav>

          {/* Mobile Breadcrumbs */}
          <nav class="breadcrumb is-hidden-desktop" aria-label="breadcrumbs">
            <ul>
              <li class="">
                <Link to={`/users`} aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faArrowLeft} />
                  &nbsp;Back to Users
                </Link>
              </li>
            </ul>
          </nav>

          {/* Content */}
          <nav class="box">
            <div
              class={`modal ${selectedSessionForDeletion ? "is-active" : ""}`}
            >
              <div class="modal-background"></div>
              <div class="modal-card">
                <header class="modal-card-head">
                  <p class="modal-card-title">Are you sure?</p>
                  <button
                    class="delete"
                    aria-label="close"
                    onClick={onDeselectSessionForDeletion}
                  ></button>
                </header>
                <section class="modal-card-body">
                  You are about to delete this session and all the data inside
                  of it. This action is cannot be undone. Are you sure you would
                  like to continue?
                </section>
                <footer class="modal-card-foot">
                  <button
                    class="button is-success"
                    onClick={onDeleteConfirmButtonClick}
                  >
                    Confirm
                  </button>
                  <button class="button" onClick={onDeselectSessionForDeletion}>
                    Cancel
                  </button>
                </footer>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <h1 class="title is-4">
                  <FontAwesomeIcon className="fas" icon={faUsers} />
                  &nbsp;User - {user.firstName} {user.lastName}
                </h1>
              </div>
              {!isFetching && (
                <div class="column has-text-right">
                  <button
                    class="button is-small is-info is-fullwidth-mobile"
                    onClick={defaultFetchList}
                  >
                    <FontAwesomeIcon className="mdi" icon={faRefresh} />
                    <span className="is-hidden-desktop is-hidden-tablet">
                      &nbsp;Refresh
                    </span>
                  </button>
                  &nbsp;
                  <button
                    onClick={(e, i) => {
                      setShowFilter(!showFilter);
                    }}
                    class="button is-small is-link is-fullwidth-mobile"
                    type="button"
                  >
                    <FontAwesomeIcon className="mdi" icon={faFilter} />
                    &nbsp;Filter
                  </button>
                </div>
              )}
            </div>

            {/* Tab Navigation */}
            <div class="tabs is-medium">
              <ul>
                <li>
                  <Link class="is-active" to={`/user/${uid}`}>
                    Detail
                  </Link>
                </li>
                <li>
                  <Link to={`/user/${uid}/sessions`}>Sessions</Link>
                </li>
                <li>
                  <Link>
                    <strong>Activities</strong>
                  </Link>
                </li>
                <li>
                  <Link onClick={() => onReportClick(uid)}>
                    Report&nbsp;
                    <FontAwesomeIcon
                      className="mdi"
                      icon={faArrowUpRightFromSquare}
                    />
                  </Link>
                </li>
              </ul>
            </div>

            {/* Filter Box */}
            {showFilter && (
              <div
                class="has-background-white-bis"
                style={{ borderRadius: "15px", padding: "20px" }}
              >
                {/* Filter Title + Clear Button */}
                <div class="columns">
                  <div class="column is-half">
                    <strong>
                      <u>
                        <FontAwesomeIcon className="mdi" icon={faFilter} />
                        &nbsp;Filter
                      </u>
                    </strong>
                  </div>
                  <div class="column is-half has-text-right">
                    <Link onClick={onClearFilterClick}>
                      <FontAwesomeIcon
                        className="mdi"
                        icon={faFilterCircleXmark}
                      />
                      &nbsp;Clear Filter
                    </Link>
                  </div>
                </div>

                {/* Filter Options */}
                <div class="columns">
                  <div class="column is-half">
                    <FormInputFieldWithButton
                      label={"Search"}
                      name="temporarySearchText"
                      type="text"
                      placeholder="Search by name"
                      value={temporarySearchText}
                      helpText=""
                      onChange={(e) => setTemporarySearchText(e.target.value)}
                      isRequired={true}
                      maxWidth="100%"
                      buttonLabel={
                        <>
                          <FontAwesomeIcon className="fas" icon={faSearch} />
                        </>
                      }
                      onButtonClick={onSearchButtonClick}
                    />
                  </div>
                  <div class="column">
                    <div class="">
                      <FormSelectField
                        label="Select Type"
                        name="type"
                        placeholder="Text input"
                        selectedValue={status}
                        options={ACTIVITIES_LIST_OPTIONS}
                        errorText={errors && errors.status}
                        helpText=""
                        onChange={(e) => setStatus(e.target.value)}
                        maxWidth="150px"
                      />
                    </div>
                  </div>
                  <div class="column">
                    <FormSelectField
                      label="Created"
                      name="created"
                      placeholder="Text input"
                      selectedValue={parseInt(created)}
                      options={USER_CREATED_LIST_OPTIONS}
                      errorText={errors && errors.created}
                      helpText=""
                      onChange={(e) => setCreated(parseInt(e.target.value))}
                      maxWidth="150px"
                    />
                  </div>
                </div>
              </div>
            )}

            {isFetching ? (
              <>
                <PageLoadingContent displayMessage={"Please wait"} />
              </>
            ) : (
              <>
                <FormErrorBox errors={errors} />
                {listData &&
                (listData.length > 0 || previousCursors.length > 0) ? (
                  <div class="container">
                    {/* for desktop view only */}
                    <div class="is-hidden-touch">
                      <ActivitiesListDesktop
                        listData={listData}
                        setPageSize={setPageSize}
                        pageSize={pageSize}
                        previousCursors={previousCursors}
                        onPreviousClicked={onPreviousClicked}
                        onNextClicked={onNextClicked}
                      />
                    </div>

                    {/* for table or mobile view */}
                    <div class="is-fullwidth is-hidden-desktop">
                      <ActivitiesListMobile
                        listData={listData}
                        setPageSize={setPageSize}
                        pageSize={pageSize}
                        previousCursors={previousCursors}
                        onPreviousClicked={onPreviousClicked}
                        onNextClicked={onNextClicked}
                      />
                    </div>
                  </div>
                ) : (
                  <div class="hero-body">
                    <p class="title">
                      <FontAwesomeIcon className="fas" icon={faTable} />
                      &nbsp;No data
                    </p>
                  </div>
                )}
              </>
            )}

            <div class="columns pt-5">
              <div class="column is-half">
                <Link to="/users" class="button is-fullwidth-mobile">
                  <FontAwesomeIcon className="fas" icon={faArrowLeft} />
                  &nbsp;Back to Users
                </Link>
              </div>
            </div>
          </nav>
        </section>
      </div>
    </>
  );
}

export default Activities;
